import { FunctionComponent } from 'react';
import Head from 'next/head';
import Layout from '../../layouts/Layout';
import Container from '../../components/Container';

export const CoursesPage: FunctionComponent = () => {
    return (
        <>
            <Head>
                <meta
                    name="robots"
                    content="noindex, nofollow, noarchive, nosnippet, noimageindex"
                />
            </Head>
            <Layout
                title="Cademy Marketplace (Coming Soon)"
                description="The new Cademy marketplace is coming soon. Check back later for exciting new courses and learning opportunities."
                path="courses"
            >
                <Container>
                    <div
                        style={{
                            textAlign: 'center',
                            padding: '4rem 2rem',
                            minHeight: 'calc(100vh - 400px)',
                        }}
                    >
                        <h1 style={{ fontSize: '2.5rem', marginBottom: '1rem', color: '#333' }}>
                            New Marketplace Coming Soon! 🚀
                        </h1>
                        <p
                            style={{
                                fontSize: '1.2rem',
                                lineHeight: '1.6',
                                color: '#666',
                                marginBottom: '2rem',
                                maxWidth: '600px',
                                margin: '0 auto 2rem',
                            }}
                        >
                            We&apos;re working hard on an exciting new marketplace experience that
                            will make discovering and accessing courses easier than ever before.
                        </p>
                        <p style={{ fontSize: '1.1rem', color: '#888', marginBottom: '2rem' }}>
                            Please check back soon for updates!
                        </p>
                    </div>
                </Container>
            </Layout>
        </>
    );
};

export default CoursesPage;
